import React, { useEffect, useRef, useState } from "react";

import { BsCardChecklist, BsArrowRightShort, BsClockFill } from 'react-icons/bs';
import { FaVoteYea } from 'react-icons/fa';
import { MdTimerOff } from 'react-icons/md';
import { BiExit, BiExport } from 'react-icons/bi';
import { ref, uploadBytes } from "firebase/storage";
import { db, storage } from "../firebase/config";
import Web3EthContract from "web3-eth-contract";
import GovernanceContract from '../getAbis/governance.json';
import UsdcContract from '../getAbis/usdc.json';
import StakeContract from '../getAbis/stake.json';

import Menu from '../Home/Menu';
import Footer from '../Home/Footer';
import $ from 'jquery'

import './custom.css';
import { useWeb3React } from "@web3-react/core";
import SelectWalletModal from "../walletConnect/modal";
import swal from "sweetalert";
import { doc, setDoc } from "firebase/firestore";
import { providerURL, truncateAddress } from "../walletConnect/utils";
import useWindowDimensions from "../../hooks/windowSize";

const Proposalcreate = () => {
  //Wallet Connection 
  const {
    account,
    active, library
  } = useWeb3React();
  const [isOpen, setIsOpen] = useState(false)
  const [filePath, setFilePath] = useState(null)
  const [isFileUploading, setIsFileUploading] = useState(false)
  const [isFileUploaded, setIsFileUploaded] = useState(false)
  const [refresh, setRefresh] = useState(false)
  const [submitButtonStatus, setSubmitButtonStatus] = useState(false)
  const [marketingWalletBalance, setMarketingWalletBalance] = useState(0)
  const [fundRequestAmount, setFundRequestAmount] = useState()
  const [amountError, setAmountError] = useState('')
  const [title, setTitle] = useState('')
  const [description, setDescription] = useState('')
  const [website, setWebsite] = useState('')
  const [twitter, setTwitter] = useState('')
  const [canSubmit, setCanSubmit] = useState(false)
  const [error, setError] = useState('')
  const [topStakerList, setTopStakerList] = useState([])
  const maxFundRaiseRequest = 10000;
  const { width } = useWindowDimensions()
  const onOpen = (e) => {
    setIsOpen(true)
  };
  const onClose = (e) => {
    setIsOpen(false)
  };
  useEffect(() => {
    console.log("file path ", filePath)
  }, [filePath])

  useEffect(() => {
    $('.onlynumericwithdecimal').bind('keypress', function (e) {
      var code = (e.which) ? e.which : e.keyCode;
      if (code == 46) {
        //Check if the text already contains the . character
        if (this.value.indexOf('.') === -1) {
          return true;
        } else {
          return false;
        }
      } else {
        if (code > 31 &&
          (code < 48 || code > 57))
          return false;
      }
      return true;
    });
  }, [])

  useEffect(() => {
    getData();
  }, [active, account, refresh])

  const getData = async () => {
    const { ethereum } = window;

    if (active) {
      Web3EthContract.setProvider(library.provider);
    } else {
      let provider = providerURL()
      Web3EthContract.setProvider(provider);
    }
    const governance_contract = new Web3EthContract(GovernanceContract.abi, GovernanceContract.GOVERNANCE_ADDRESS);
    const usdc_contract = new Web3EthContract(UsdcContract.abi, UsdcContract.USDC_ADDRESS);
    const stake_contract = new Web3EthContract(StakeContract.abi, StakeContract.STAKE_ADDRESS);

    let marketingAddress = await governance_contract.methods.marketing().call();
    setMarketingWalletBalance(await usdc_contract.methods.balanceOf(marketingAddress).call() / 10 ** 6)
    if (active) {
      let isEligibleToPropose = await stake_contract.methods.checkHighestStaker(account).call();
      if (isEligibleToPropose) {
        setSubmitButtonStatus(true)
        setCanSubmit(true)
        setError("")
      } else {
        setCanSubmit(false)
        setSubmitButtonStatus(false)
        setError("Only top stakers can submit proposal")
      }

      // let latestProposals = await governance_contract.methods.latestProposalIds(account).call()
    }
    for (let i = 0; i < 30; i++) {
      try {
        let highestStakerData = await stake_contract.methods.highestStakerInPool(0, i).call();
        console.log("staker address ", highestStakerData)
        if (highestStakerData && !topStakerList.includes(highestStakerData.stakerAddress)) {
          setTopStakerList(current => [...current,
          {
            stakerAddress: highestStakerData.addr,
            stakedAmount: highestStakerData.deposited / 10 ** 18
          }])
        }
      } catch (e) {
        break;
      }
    }
  }

  useEffect(() => {
    // setAmountError('')
    console.log("amount here ", (fundRequestAmount))
    console.log("balance ", marketingWalletBalance)
    if (fundRequestAmount > maxFundRaiseRequest) {
      setFundRequestAmount(maxFundRaiseRequest)
      setAmountError("You can request for maximum of 10,000 USD")
    } else if (fundRequestAmount > marketingWalletBalance) {
      if (marketingWalletBalance == 0) {
        setAmountError("Funds not available, please try again later")
        setSubmitButtonStatus(false)
      } else {
        setSubmitButtonStatus(true)
        setFundRequestAmount(marketingWalletBalance)
        setAmountError("This is maximum fund you can request for now")
      }
    }
    // else if (fundRequestAmount < 1) {
    //   setSubmitButtonStatus(false)
    //   setAmountError("Fund request amount should be atleast 1 USDC")
    // } 
    else if (parseFloat(fundRequestAmount) * 10 ** 18 < 1 * 10 ** 18) {
      setSubmitButtonStatus(false)
      setAmountError("Fund request amount should be atleast 1 USDC")
      // setFundRequestAmount(1)
    }
    else {

    }
    if (fundRequestAmount > 0 && fundRequestAmount < maxFundRaiseRequest && fundRequestAmount < marketingWalletBalance) {
      setSubmitButtonStatus(true)
      setAmountError('')
    }
    // else {
    //   setAmountError("")
    // }
  }, [fundRequestAmount]);

  const submitProposal = async () => {
    // if (filePath == null) {
    //   swal({
    //     title: "ERROR : File Not Found",
    //     text: "Please upload a file",
    //     icon: "error",
    //     showCancelButton: false,
    //     confirmButtonClass: "btn-danger",
    //     confirmButtonText: "Close",
    //     closeOnConfirm: false
    //   });
    // } else 
    if (title == '' || description == '') {
      swal({
        title: "ERROR : Invalid Input",
        text: "Please provide valid title and descrption",
        icon: "error",
        showCancelButton: false,
        confirmButtonClass: "btn-danger",
        confirmButtonText: "Close",
        closeOnConfirm: false
      });
    } else {
      // setIsFileUploading(true)
      const { ethereum } = window;
      Web3EthContract.setProvider(ethereum);
      const governance_contract = new Web3EthContract(GovernanceContract.abi, GovernanceContract.GOVERNANCE_ADDRESS);
      console.log("fund amount ", fundRequestAmount)
      let amount = String(fundRequestAmount * 10 ** 6);
      await governance_contract.methods.propose(amount, title).estimateGas({
        from: account
      }).then(async function (gasAmount) {
        let tx = await governance_contract.methods.propose(amount, title).send({
          from: account
        }, function (error, tx) {
          if (error) {
            swal({
              title: "Error Found",
              text: error.message,
              icon: "error",
              showCancelButton: false,
              confirmButtonClass: "btn-danger",
              confirmButtonText: "Close",
              closeOnConfirm: false
            });
          } else {
            swal({
              title: "Proposal Submitted Successfully",
              text: "Please do not close or refresh page till file is uploaded.",
              icon: "success",
              showCancelButton: false,
              confirmButtonClass: "btn-danger",
              confirmButtonText: "Close",
              closeOnConfirm: false
            });
          }
        });
        if (tx.status) {
          let proposalCount = await governance_contract.methods.proposalCount().call();
          await uploadFileToDB(proposalCount)
        }
      }).catch(function (error) {
        // setIsFileUploading(false)
        if (error.message.includes('eth_estimateGas')) {
          swal({
            title: "Error Found",
            text: 'Insufficient Funds For Transaction',
            icon: "error",
            showCancelButton: false,

            confirmButtonText: "Close",
            closeOnConfirm: false
          });
        } else if (error.message.includes('one live proposal per proposer')) {
          swal({
            title: "Proposal Already Exists",
            text: 'Already submitted a proposal with active status',
            icon: "error",
            showCancelButton: false,

            confirmButtonText: "Close",
            closeOnConfirm: false
          });
        } else if (error.message.includes('min 1 USDC limit')) {
          setFundRequestAmount(1)
          swal({
            title: "ERROR : Fund Request",
            text: 'Minimum fund request should be 1 USDC',
            icon: "error",
            showCancelButton: false,

            confirmButtonText: "Close",
            closeOnConfirm: false
          });
        } else {
          swal({
            title: "Error Found",
            text: error.message,
            icon: "error",
            showCancelButton: false,
            confirmButtonClass: "btn-danger",
            confirmButtonText: "Close",
            closeOnConfirm: false
          });
        }
      });
    }
  }

  const uploadFileToDB = async (proposalCount) => {
    let propNum = parseInt(proposalCount);

    try {
      const docRef = doc(db, 'Proposals', `${propNum}`)
      await setDoc(docRef, {
        title,
        description,
        website,
        twitter,
        walletAddress: account
      })
    } catch (error) {
      console.error("ERROR : Firebase ==>", error)
      swal({
        title: "ERROR : Firebase",
        text: "Something went wrong, please contact the owner",
        icon: "error",
        showCancelButton: false,
        confirmButtonClass: "btn-danger",
        confirmButtonText: "Close",
        closeOnConfirm: false
      });
    }

    // const fileRef = ref(storage, `${propNum}/${filePath.name}`);
    // uploadBytes(fileRef, filePath).then(async () => {
    //   // setIsFileUploaded(true)
    //   // setIsFileUploading(false)

    // }).then(() => {
    //   swal({
    //     title: "File Uploded Successfully",
    //     // text: "",
    //     icon: "success",
    //     showCancelButton: false,
    //     confirmButtonClass: "btn-danger",
    //     confirmButtonText: "Close",
    //     closeOnConfirm: false
    //   });
    //   setRefresh(!refresh)
    // }).catch((error) => {
    //   console.log("error file upload ", error)
    //   swal({
    //     title: "ERROR : File Could NOT be Uploaded",
    //     text: "Something went wrong, please contact the owner",
    //     icon: "error",
    //     showCancelButton: false,
    //     confirmButtonClass: "btn-danger",
    //     confirmButtonText: "Close",
    //     closeOnConfirm: false
    //   });
    // });
  }
  return (
    <>
      <Menu />
      <section className="proPosal DaoMainSection DAOSlider sliderSection">

        <img src="./images/glowlogo.png" className="img-responsive glowlogo" />
        <div className="container">

          {/* {canSubmit ?
            <></>
            :
            <h4 className="text-left text-danger">You cannot submit proposal</h4>
          } */}
          <h4 className="text-left text_high">Make a Proposal</h4>
          <div className="row">
            <div className="col-sm-8">




              <div className="single_cart">
                <div className="form-group">
                  <h5>Title*</h5>
                  <input type="text" name="" className="form-control" onChange={e => setTitle(e.target.value)} required />
                </div>
                <div className="form-group">
                  <h5>Content*</h5>
                  <label>Tip: write in Markdown!</label>
                  <textarea type="text" rows="8" name="" className="form-control" onChange={e => setDescription(e.target.value)} required></textarea>
                </div>
                {/* <div className="special_form">
                    <div className="form-group">
                      <h5>Choices</h5>
                      <div className="radioss">
                        <div className="sn_radio"><input type="radio" id="Vote" value="Vote"/><label className="label" for="Vote">Vote Now</label></div>
                        <div className="sn_radio"><input type="radio" id="Soon" value="Soon"/><label className="label" for="Soon">Soon</label></div>
                        <div className="sn_radio"><input type="radio" id="Close" value="Close"/><label className="label" for="Close">Close</label></div>
                        <button className="orenge_btn">Add Choice</button>
                      </div>
                    </div>
                  </div> */}
              </div>

              {width > 972 ?
                <div className="single_cart list topstakers mt-2">
                  <h2>Top Stakers</h2>
                  <div className="si_list px-2">
                    <div className="col-12" >
                      <div className="row" >
                        <div className="col-2">Sr. No.</div>
                        <div className="col-6">Staker</div>
                        <div className="col-4">Staked TGC</div>
                      </div>
                    </div>
                    <br />
                    {topStakerList.map((item, index) => {

                      if (true) {
                        return (
                          <div className="col-12" key={index}>
                            <div className="row" >
                              <div className="col-2">
                                {parseInt(index) + 1}
                              </div>
                              <div className="col-6">
                                <p>
                                  <a href={`https://etherscan.io/address/${item.stakerAddress}`} className="m-1">
                                    <span className="text-white">
                                      {width < 972 ?
                                        <>{truncateAddress(item.stakerAddress)} <BiExport /></>
                                        :
                                        <>{(item.stakerAddress)} <BiExport /></>
                                      }
                                    </span>
                                  </a>
                                </p>
                              </div>
                              <div className="col-4">
                                <p className="text-danger">{parseFloat(item.stakedAmount).toFixed(2)} TGC</p>
                                {/* {item.type == 1 ?
                                :
                                <>
                                  {item.type == 0 ?
                                    <p className="text-danger">Absolutely Diagree <ImCross /></p>
                                    :
                                    <p className="text-warning">Not Sure <AiOutlineStop /></p>
                                  }
                                </>
                              } */}
                              </div>
                            </div>
                            <hr />
                          </div>
                        )
                      }
                    })
                    }
                  </div>
                </div>
                :
                <></>
              }
            </div>

            <div className="col-sm-4">
              <div className="portal_box single_cart">
                <h5>Actions</h5>

                <div className="form-group">
                  <label>Proposal For*</label>
                  <input type="text" name="" className="form-control" value='7 Days From Now' placeholder="7 Days From Now" readOnly />
                </div>
                <div className="form-group">
                  <label>Website Link</label>
                  <input type="text" name="" className="form-control" onChange={e => setWebsite(e.target.value)} placeholder="https://www.thegrays.com" />
                </div>
                <div className="form-group">
                  <label>Twitter Link</label>
                  <input type="text" name="" className="form-control" onChange={e => setTwitter(e.target.value)} placeholder="https://twitter.com/MrBeast" />
                </div>
                <div className="form-group">
                  <label>Funds Request (in USD)*</label>
                  <input type="number" name="" value={fundRequestAmount} className="form-control onlynumericwithdecimal" placeholder="Enter Amount in USD" onChange={(e) => setFundRequestAmount(e.target.value)} />
                  <p className="text-danger">{amountError}</p>
                </div>
                {/* <div className="form-group">
                  <label>Proof Of Completion*</label>
                  <input type="file" name="" className="form-control" onChange={(e) => { setFilePath(e.target.files[0]) }} required />
                </div> */}
                <div className="snaps">
                  {/* {isFileUploading ?
                    <>
                      {isFileUploaded ?
                        <p className="text-success">File Uploaded Successfully</p>
                        :
                        <p className="text-danger">Uplaoding File..</p>
                      }
                    </>
                    :
                    <></>
                  } */}
                  {/* <label>Shapshot <a href="#"><span>23837904 <BiExport /></span></a></label> */}
                  <br />
                  <p className="text-danger text-center">{error}</p>
                  {active ?
                    <>
                      {submitButtonStatus ?
                        <button className="orenge_btn" onClick={submitProposal}>Submit Proposal</button>
                        :
                        <button className="orenge_btn" disabled>Submit Proposal</button>
                      }
                    </>
                    :
                    <button className="orenge_btn" onClick={onOpen}>Connect Wallet</button>
                  }
                </div>
              </div>


              {width <= 972 ?
                <div className="single_cart list topstakers mt-2">
                  <h2 className="px-2">Top Stakers</h2>
                  <div className="si_list px-2">
                    <div className="col-12" >
                      <div className="row" >
                        <div className="col-2">Sr. No.</div>
                        <div className="col-6">Staker</div>
                        <div className="col-4">Staked TGC</div>
                      </div>
                    </div>
                    <br />
                    {topStakerList.map((item, index) => {

                      return (
                        <div className="col-12" key={index}>
                          <div className="row" >
                            <div className="col-2">
                              {parseInt(index) + 1}
                            </div>
                            <div className="col-6">
                              <p>
                                <a href={`https://etherscan.io/address/${item.stakerAddress}`} className="m-1">
                                  <span className="text-white">
                                    {width < 972 ?
                                      <>{truncateAddress(item.stakerAddress)} <BiExport /></>
                                      :
                                      <>{(item.stakerAddress)} <BiExport /></>
                                    }
                                  </span>
                                </a>
                              </p>
                            </div>
                            <div className="col-4">
                              <p className="text-danger">{parseFloat(item.stakedAmount).toFixed(2)} TGC</p>
                              {/* {item.type == 1 ?
                              :
                              <>
                                {item.type == 0 ?
                                  <p className="text-danger">Absolutely Diagree <ImCross /></p>
                                  :
                                  <p className="text-warning">Not Sure <AiOutlineStop /></p>
                                }
                              </>
                            } */}
                            </div>
                          </div>
                          <hr />
                        </div>
                      )
                    })
                    }
                  </div>
                </div>
                :
                <></>
              }
            </div>
          </div>
        </div>
      </section>

      <SelectWalletModal isOpen={isOpen} closeModal={onClose} />
      <Footer />
    </>
  );
};
export default Proposalcreate;